import { render } from "./QuizGroup.vue?vue&type=template&id=7b76e858"
import script from "./QuizGroup.vue?vue&type=script&lang=js"
export * from "./QuizGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__